import React from 'react';

import { useRecoilValue } from 'recoil';

import { blockDisplayHeader, customizedBlock, isReportState } from 'venn-state';
import { useAnalysis } from '../../../studio-blocks/logic/useAnalysis';

import { Block } from '../../components/core';
import { DefaultSubjects } from '../../components/secondary/subjects/default-subjects';
import { HoldingsCalculationInfo } from '../../components/secondary/holdings-calculation-info';

interface PortfolioCompositionHeaderProps {
  id: string;
}

export const PortfolioCompositionHeader = ({ id }: PortfolioCompositionHeaderProps) => {
  const { selectedMetrics, relativeToBenchmark } = useRecoilValue(customizedBlock(id));
  const title = useRecoilValue(blockDisplayHeader(id));
  const { subHeader } = useRecoilValue(customizedBlock(id));
  const isReport = useRecoilValue(isReportState);

  const { analyses } = useAnalysis(id);
  const analysis = analyses?.[0]?.[0];
  const portfolioBreakdownResponse = analysis?.portfolioBreakdown?.[0];
  const hasNegativeAssets = portfolioBreakdownResponse?.hasNegativeAssets;

  return (
    <>
      <Block.HeaderTopContainer id={id}>
        <Block.Title>
          <Block.Headline id={id}>{title}</Block.Headline>
          {subHeader && <Block.SubHeadline id={id}>{subHeader}</Block.SubHeadline>}
        </Block.Title>
        {hasNegativeAssets && (
          <Block.Metadata id={id}>
            <HoldingsCalculationInfo breakdownType="Long Rescaled Values" />
          </Block.Metadata>
        )}
      </Block.HeaderTopContainer>
      <DefaultSubjects
        id={id}
        metric={selectedMetrics[0]}
        relativeToBenchmark={relativeToBenchmark}
        forceShowSubjects
        isColorless={isReport}
      />
    </>
  );
};
